import React, { useRef } from 'react';

const toNumber = (value, fallback) => {
  if (value === undefined || value === null || value === '') return fallback;
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

// La escala va siempre de 0 a 10 como mucho: aunque venga otra cosa guardada
// (o la proponga la IA), aqui se recorta.
export const RATING_MIN = 0;
export const RATING_MAX = 10;

export const clampRating = (minValue, maxValue) => {
  const min = Math.min(RATING_MAX - 1, Math.max(RATING_MIN, toNumber(minValue, RATING_MIN)));
  const max = Math.min(RATING_MAX, Math.max(min + 1, toNumber(maxValue, RATING_MAX)));
  return { min, max };
};

export const ratingScale = (question) => clampRating(question.minValue, question.maxValue);

const RatingQuestion = ({ question, value, onChange, labelledBy }) => {
  const { min, max } = ratingScale(question);
  const values = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  const listRef = useRef(null);
  const selected = value === undefined || value === null || value === '' ? null : Number(value);

  const moveFocus = (event, index) => {
    const keys = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 };
    if (!(event.key in keys)) return;
    event.preventDefault();
    const next = Math.min(values.length - 1, Math.max(0, index + keys[event.key]));
    const buttons = listRef.current ? listRef.current.querySelectorAll('button') : [];
    if (buttons[next]) buttons[next].focus();
    onChange(String(values[next]));
  };

  return (
    <div
      ref={listRef}
      className={`tp-answer__scale ${values.length > 7 ? 'is-long' : ''}`.trim()}
      role="radiogroup"
      aria-labelledby={labelledBy}
      style={{ '--scale-count': values.length }}
    >
      {values.map((number, index) => {
        const isSelected = selected === number;
        const focusable = selected === null ? index === 0 : isSelected;
        return (
          <button
            key={number}
            type="button"
            role="radio"
            aria-checked={isSelected}
            tabIndex={focusable ? 0 : -1}
            className={`tp-answer__scale-btn ${isSelected ? 'is-selected' : ''}`.trim()}
            onClick={() => onChange(String(number))}
            onKeyDown={(event) => moveFocus(event, index)}
          >
            {number}
          </button>
        );
      })}
    </div>
  );
};

export default RatingQuestion;
